import { createCachedSelector } from 're-reselect';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as api from '../../services/api';

import { QUERY_CACHE_TIME } from '../../constants';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data, storeKey) => storeKey,
  (data) => {
    const { fiscalPeriods, activeFiscalPeriod } = data || {};

    return { fiscalPeriods, activeFiscalPeriod };
  }
)({
  keySelector: (data, storeKey) => storeKey
});

const useFiscalPeriod = () => {
  const { accountId } = useAccount();
  const queryClient = useQueryClient();

  const storeKey = ['fiscalPeriod', accountId];
  const { isLoading, data } = useQuery(storeKey, async () => api.fetchFiscalPeriods({ accountId }), {
    enabled: !!accountId,
    select: (fiscalPeriodsData) => selector(fiscalPeriodsData, storeKey.join('#')),
    cacheTime: QUERY_CACHE_TIME
  });

  const { fiscalPeriods = [], activeFiscalPeriod = undefined } = data || {};

  const { mutateAsync: addFiscalPeriod } = useMutation(
    ({ startDate, endDate }) =>
      api.addFiscalPeriod({
        accountId,
        startDate,
        endDate
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(storeKey);
      }
    }
  );

  return {
    isLoading,
    fiscalPeriods,
    activeFiscalPeriod,
    addFiscalPeriod
  };
};

export default useFiscalPeriod;
